<template>
  <v-select
  v-if="items"
  @click="stopPropagation ? $event.stopPropagation() : null"
  @change="versionSelected"
  v-model="selectedVersion"
  :items="items"
  return-object
  item-value="effectiveDate"
  solo
  flat
  dense
  class="mb-n6"
  :label="$t('date')"
  :disabled="disabled">
    <template #item="{ item }">
      <Icon
      :iconColor="item.status.color"
      :icon="item.status.icon"
      :tooltipText="$t(item.status.name)"
      :small="false"/>
      <span>
        {{ formatDate(item.effectiveDate) }}
      </span>
    </template>
    <template #selection="{ item }">
      <v-row align="center" dense>
        <v-col cols="auto">
          <Icon
          :iconColor="item.status.color"
          :icon="item.status.icon"
          :tooltipText="$t(item.status.name)"
          :small="false"/>
        </v-col>
        <v-col>
          <span>
            {{ formatDate(item.effectiveDate) }}
          </span>
        </v-col>
      </v-row>
    </template>
  </v-select>
</template>

<script>
import { formatDate } from '@/utils/DateFormatter.js'
import { VersionedRateSheetStatus, assignVersionedRateSheetStatus } from '@/components/account/account-scaling/rate-sheet-definitions/RateSheetDefinitions'
import { minBy, maxBy } from 'lodash'
import moment from 'moment'

export default {
  name: 'RateSheetDefinitionVersionSelector',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    stopPropagation: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data: () => ({
    selectedVersion: null
  }),

  mounted () {
    this.setSelectionToActiveVersion()
  },

  watch: {
    items () {
      this.setSelectionToActiveVersion()
    }
  },

  methods: {
    formatDate,

    setSelectionToActiveVersion () {
      this.ensureVersionsHaveStatus()
      this.versionSelected(this.getCurrentVersion())
    },

    ensureVersionsHaveStatus () {
      if (this.items.some(item => !item?.status)) {
        assignVersionedRateSheetStatus(this.items)
      }
    },

    getCurrentVersion () {
      const current = this.items.find(item => item.status.id === VersionedRateSheetStatus.Active.id)
      if (current) return current
      const future = this.items.filter(item => item.status.id === VersionedRateSheetStatus.Inactive.id)
      if (future.length > 0) return minBy(future, item => moment(item.effectiveDate).unix())
      const expired = this.items.filter(item => item.status.id === VersionedRateSheetStatus.Expired.id)
      if (expired.length > 0) return maxBy(expired, item => moment(item.effectiveDate).unix())
      return []
    },

    versionSelected (version) {
      this.selectedVersion = version
      this.$emit('chosen', version)
    }
  }
}
</script>
